<template>
  <a-flex vertical gap="large">
    <a-typography-text strong class="label-name">
      {{ labelName || "Название этикетки" }}
    </a-typography-text>

    <a-flex gap="large">
      <LabelTemplateEditMainFields :loading="loading" />

      <LabelTemplateEditPreview :loading="loading" />
    </a-flex>
  </a-flex>
</template>

<script setup lang="ts">
import { useLabelTemplateFormStore } from "@/stores/labelTemplate/labelTemplateFormStore";
import { computed } from "vue";
import LabelTemplateEditMainFields from "@/components/settings/labels/labelTemplateEdit/labelTemplateEditMain/LabelTemplateEditMainFields.vue";
import LabelTemplateEditPreview from "@/components/settings/labels/labelTemplateEdit/labelTemplateEditMain/LabelTemplateEditPreview.vue";

defineProps<{ loading: boolean }>();

const labelTemplateFormState = useLabelTemplateFormStore();

const labelName = computed(() => labelTemplateFormState.nameField);
</script>

<style scoped lang="scss">
.label-name {
  padding: 8px 16px;
  background: var(--color-border);
  border-radius: 10px;
  width: fit-content;
  font-size: 16px;
}
</style>
